export default __webpack_public_path__ + "static/media/view_from_belvedere.02773629.jpg";